<template>
  <div class="blank-layout">
    <router-view />
    <global-tabbar />
  </div>
</template>

<script>
import GlobalTabbar from '@/components/GlobalTabbar';

export default {
  components: {
    GlobalTabbar,
  },
};
</script>
<style lang="less" scoped></style>
